
























































import { Component, Prop, Vue } from 'vue-property-decorator';

export interface Button {
  name: string,
  id: string,
  isActive: Boolean
}

@Component
export class BottomWrapper extends Vue {
  @Prop({ default: () => [] }) readonly buttons!: Button [];
  @Prop({ default: () => ({
    isErr: false,
    message: '',
  }) }) readonly errInfo!: {isErr: boolean, message: string}
  close = false;
  @Prop({ default: false }) readonly isFixed!: boolean;

  get errorMsg () {
    if (!this.errInfo.isErr) return '';
    return this.errInfo.message ? this.errInfo.message : 'Looks like there is some technical issue, please try it again.';
  }

  toggle () {
    this.close = !this.close;
  }
  handleClick (button: Button) {
    this.$emit('select', button);
  }
  retry () {
    this.$emit('retry');
  }
}

export default BottomWrapper;
